import {
  getTotalDetailsAggregationDefinition,
} from '@common/services/provision/taxExpenseDetailsAggregationDefinitions';
import { GroupBy, BookType } from '@common/types/aggregationDefinitions';

type Details = {
  [key: string]: { // report name
    data: {
      [key: string]: { // section name
        data: {
          groupItem: string,
          disallowedAmtTot: number | null,
          tagName: string | null,
          account: string,
          isTotal?: boolean,
        }[]
      }
    }
  }
}

export const calculateDetailsTotals = (
  detailRows: Details,
  groupType: GroupBy,
  getTotalColumns: (bookType: string) => string[],
  ignoreCurrency?: boolean
) => {
  Object.keys(detailRows).forEach(reportId => {
    const reportData = detailRows[reportId].data;
    const totalColumns = getTotalColumns(reportId);
    Object.keys(reportData).forEach(reportLineType => {
      const details = reportData[reportLineType].data;
      const aggregationDefinition = getTotalDetailsAggregationDefinition(
        reportLineType,
        groupType,
        reportId as BookType,
        ignoreCurrency
      );
      const sums = {} as Record<string, {tagName: string | null, value: number | null, isTotal?: boolean }>;
      details.forEach(({ disallowedAmtTot, account, tagName }) => {
        switch (aggregationDefinition || 'sum') {
          case 'sum': {
            if (!sums[account]) {
              sums[account] = {
                value: 0,
                tagName,
                isTotal: true,
              };
            }
            sums[account].value = (sums[account].value || 0) + (disallowedAmtTot || 0);
            break;
          }
          case 'ignore':
            sums[account] = {
              value: null,
              tagName,
              isTotal: false,
            };
            break;
          default:
            throw new Error(`Unknown aggregation definition: ${aggregationDefinition}`);
        }
      });
      Object.keys(sums).forEach(account => {
        totalColumns.forEach(totalColumn => {
          details.push({
            groupItem: totalColumn,
            disallowedAmtTot: sums[account].value,
            tagName: sums[account].tagName,
            account,
            isTotal: sums[account].isTotal,
          });
        });
      });
    });
  });
  return detailRows;
};
